import { render, staticRenderFns } from "./AssignedTasksPage.vue?vue&type=template&id=735902b0"
import script from "./AssignedTasksPage.vue?vue&type=script&lang=js"
export * from "./AssignedTasksPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports